<template lang="pug">
    div.main-container(:style="{backgroundSize:'cover', backgroundImage:'url(' + require('@/assets/img2/insigne-bg-stroke-grey.png') + ')'} ")
        div.overlay
        
        <!--  BEGIN CONTENT PART  -->
        div.main-content(id="content")
            div.layout-px-spacing
                div.page-header
                    div.page-title
                        h3  {{ $t('centersinvent.invmov')}}
                    
                    div
                       nav.breadcrumb-one(aria-label="breadcrumb")
                          ol.breadcrumb
                              li.breadcrumb-item
                                router-link(to="/pages/home") {{ $t('headers.dashboard')}}
                              li.breadcrumb-item.active(aria-current="page")  {{ $t('centersinvent.invmov')}}
                              
                div.row.mt-5.pb-5
                    request-inventory
                    attend-inventory

                        

</template>

<script>
/* eslint-disable */
import RequestInventory from '@/views/AdminCenter/RequestInventory'
import AttendInventory from '@/views/AdminCenter/AttendInventory'
export default {
    name: 'MyCentersInventory',
    components: {
        RequestInventory, AttendInventory
    },
    data() {
        return {
        }
    },
    methods: {
    },
    mounted() {

    }
}
</script>
